import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

const DeleteComponent = ({ template, displayed, onClose, onDelete }) => {
  const [input, setInput] = useState('');

  const clearInputAndClose = () => {
    setInput('');
    onClose();
  };

  const clearInputAndDelete = () => {
    setInput('');
    onDelete();
  };
  return (
    <>
      <Dialog
        open={displayed}
        onClose={clearInputAndClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={[
            {
              borderBottom: 1,
              marginBottom: 3,
              display: 'flex',
              gap: 4,
              alignItems: 'center',
              fontSize: 24,
            },
          ]}
        >
          <>
            <DeleteIcon fontSize="large" color="error" />
            Suppression du template {template.reference}
          </>
        </DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography>Vous vous apprêtez à supprimer le template</Typography>
          <Typography color="error">{`${template.reference}: ${template.name}`}</Typography>
          <Typography>
            Veuillez saisir la référence du template pour le supprimer
          </Typography>
          <TextField
            value={input}
            onChange={(event) => setInput(event.target.value)}
          ></TextField>
          <Box
            sx={{
              width: '80%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button variant="outlined" onClick={clearInputAndClose}>
              Retour
            </Button>
            <Button
              variant="contained"
              color="error"
              disabled={input !== template.reference}
              onClick={clearInputAndDelete}
            >
              Supprimer
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DeleteComponent;
